import React, { FunctionComponent } from 'react'
import { tt } from '../../../i18n'
import WheelButton from '../../../components/cta/WheelButton'
import { PROCESS_STRING_CONFIG } from '../../helpers/PROCESS_STRING_CONFIG'
import { useSelector } from 'react-redux'
import { lotteryConfigSelector } from '../../../redux/selectors/lottery'
import { questionsSelector } from '../../../redux/selectors/quizz'
// @ts-ignore
import processString from 'react-process-string'
import QuizzLogo from './QuizzLogo'
import CONFIG from '../../../model/TSConfig'
import { QuizzSkinI } from '../skins/default'

interface Props {
  hasStepAndPerformedIt: boolean
  startQuizz: () => void
  skin: QuizzSkinI
}

const QuizzHome: FunctionComponent<Props> = ({
  hasStepAndPerformedIt,
  startQuizz,
  skin,
}) => {
  const lotteryConfig = useSelector(lotteryConfigSelector)
  const questions = useSelector(questionsSelector)

  const hasAudio = questions && questions.findIndex((q) => !!q.audio) !== -1
  const ctaText = hasAudio ? tt('quizz_blind_test_start') : tt('quizz_start')

  return (
    <>
      <div className="quizz-home-container">
        <QuizzLogo
          containerClass={'logo-container'}
          useConfig={undefined}
          isHome={true}
          skin={skin}
        />
        <div className="container">
          <div className="row">
            <div className="col-12 quizz-home-text">
              {hasStepAndPerformedIt && tt('its_all_good_no_comma')}
              {!hasStepAndPerformedIt &&
                (lotteryConfig?.qIntroText ||
                  (hasAudio
                    ? tt('quizz_blind_test_default_text')
                    : tt('quizz_answer_correctly')))}
            </div>
          </div>
          {!hasStepAndPerformedIt && !!lotteryConfig?.qIntroSubText && (
            <div className="row">
              <div className="col-12 quizz-home-sub-text">
                {lotteryConfig?.qIntroSubText}
              </div>
            </div>
          )}
          <div className="row w-margin-top">
            <div className="col-12">
              <WheelButton
                id="start-quizz"
                text={ctaText}
                onClick={startQuizz}
              />
            </div>
          </div>

          {!!lotteryConfig?.qIntroFooterText && (
            <div className="row w-margin-top">
              <div className="col-12 text-center">
                <small>
                  {processString(PROCESS_STRING_CONFIG)(
                    lotteryConfig.qIntroFooterText
                  )}
                </small>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default QuizzHome
